import { seriesToCsv } from './data';

export { seriesToCsv as toCsv };

export function downloadCsv(series, filename = 'calls-per-day.csv') {
  const url = URL.createObjectURL(new Blob([seriesToCsv(series)], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
